<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline margin-0-auto">Edit Supply Chain Data</span>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-container>
          <v-layout justify-space-between>
            <v-flex xs5>
              <component v-for="field in scmFieldsFormatted.firstHalf"
                :key="field.key"
                :is="{
                  'date': 'date-picker',
                  'text': 'v-text-field'
                }[field.type]"
                :required="field.required"
                :label="field.label"
                :disabled="field.immutable"
                :value="editedData[field.key]"
                @input="editedData[field.key] = $event"
              ></component>
            </v-flex>
            <v-flex xs5>
              <component v-for="field in scmFieldsFormatted.secondHalf"
                :key="field.key"
                :is="{
                  'date': 'date-picker',
                  'text': 'v-text-field'
                }[field.type]"
                :required="field.required"
                :label="field.label"
                :disabled="field.immutable"
                :value="editedData[field.key]"
                @input="editedData[field.key] = $event"
              ></component>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="pr-5 pb-3">
        <v-spacer></v-spacer>
        <v-btn flat @click="cancel">Cancel</v-btn>
        <v-btn color="primary" @click="edit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

import DatePicker from './DatePicker'

export default {
  name: 'edit-code-dialog',
  data () {
    return {
      extendedId: null,
      editedData: { }
    }
  },
  props: {
    dialog: Boolean,
    code: Object,
    transaction: Object
  },
  computed: {
    ...mapGetters('transactions', [
      'transactions',
    ]),
    codeData () {
      if (this.code) {
        return {
          extendedId: this.code['message'],
          campaign: this.code['campaign'],
          scmData: this.code['scm_data'],
        }
      } else if (this.transaction) {
        return {
          extendedId: this.transaction.code.extendedId,
          campaign: this.transaction.code.campaign,
          scmData: this.transaction.scmData || JSON.parse(this.transaction.value),
        }
      }
      return null
    },
    scmFields () {
      return this.codeData && this.codeData.campaign
        ? this.$store.getters['scmFields/scmFields'][this.codeData.campaign]
        : []
    },
    scmFieldsFormatted () {
      return {
        firstHalf: this.scmFields.slice(0, this.scmFields.length / 2 + 0.5),
        secondHalf: this.scmFields.slice(this.scmFields.length / 2 + 0.5)
      }
    },
    isDataReady () {
      return this.scmFields && this.codeData && this.codeData.extendedId
    },
  },
  watch: {
    isDataReady: {
      immediate: true,
      handler () {
        if (this.isDataReady) {
          this.scmFields.forEach(field => {
            this.$set(this.editedData, field.key, this.codeData.scmData[field.key])
          })
          this.extendedId = this.codeData.extendedId
        }
      }
    },
    dialog() {
      for (let key in this.editedData) {
        if (key != 'extended_id') this.editedData[key] = this.codeData.scmData[key]
      }
    }
  },
  methods: {
    cancel() {
      this.resetForm()
      this.$emit('cancel')
    },
    async edit() {
      const scm = Object.assign({}, this.codeData.scmData, this.editedData)
      await this.$emit('edit', {extendedId: this.extendedId, update: scm})
    },
    resetForm() {
      this.extendedId = null
      for (let key in this.editedData) {
        this.editedData[key] = ''
      }
    }
  },
  components: { DatePicker }
}
</script>

<style lang="scss" scoped>
.margin-0-auto{
  margin: 0 auto
}
</style>